import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { ACTION_LABELS, StatusBadge, formatWhen } from './dutiShared';
import { Loader2 } from 'lucide-react';

export const MyRequests = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get('/duti/my-requests').then(({ data }) => setRows(data.actions)).catch(() => setRows([]));
  }, []);

  if (rows === null) return <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />;
  if (!rows.length) return <p className="text-sm text-muted-foreground" data-testid="duti-my-requests-empty">You haven't asked Duti AI to draft anything yet.</p>;

  return (
    <ul className="divide-y rounded-xl border" data-testid="duti-my-requests">
      {rows.map((a) => (
        <li key={a.action_id} className="flex flex-wrap items-center justify-between gap-3 p-4" data-testid={`duti-my-request-${a.action_id}`}>
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground">{ACTION_LABELS[a.action_type]} · {formatWhen(a.created_at)}</p>
            <p className="text-sm font-medium">{a.summary}</p>
            {a.decision_note && <p className="text-xs text-muted-foreground mt-0.5">“{a.decision_note}” — {a.decided_by_name}</p>}
          </div>
          <StatusBadge status={a.status} testId={`duti-my-request-status-${a.action_id}`} />
        </li>
      ))}
    </ul>
  );
};
